import { render, staticRenderFns } from "./UserSettingAutoInventory.vue?vue&type=template&id=5dda4559&scoped=true&"
import script from "./UserSettingAutoInventory.vue?vue&type=script&lang=js&"
export * from "./UserSettingAutoInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda4559",
  null
  
)

export default component.exports